if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) if (this.submitButton && document.querySelector('cart-drawer')) { this.submitButton.setAttribute('aria-haspopup', 'dialog'); }
        

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        // Validación del preorder
        const formPreorderData = new FormData(this.form);
        const isPreorder = formPreorderData.get('properties[_preorder]') === 'true';

        try {
          const cart = await this.getCart();
          const hasPreorderInCart = this.checkPreorderInCart(cart);

          const validationResult = this.validateCart(hasPreorderInCart, isPreorder, cart.items.length);

          if (!validationResult.isValid) {
            this.handleErrorMessage(validationResult.message);
            return; // Detener el flujo si la validación falla
          }

        } catch (error) {
          console.error("Error al validar el carrito:", error);
          return;
        }
        
        if (window.innerWidth >= 750) {
          if(window.exitsSize != false) {
            let isChoseInput = false;
            let varitions = document.querySelectorAll('variant-radios');
            varitions.forEach(varition => {
              let input = varition.querySelectorAll('input[type="radio"]');
              input.forEach(item => {
                if (item.classList.contains('active') || item.checked) {
                  isChoseInput = true;
                }
              })
            })
            if(isChoseInput == false) {
              let errorVaritions = document.querySelector('.error-variant-radios')
              if(errorVaritions){
                errorVaritions.classList.remove('tw-hidden');
              }
              return;
            }
          }
        }

        if (this.submitButton && this.submitButton.hasAttribute('aria-disabled')) {
          if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        }
        this.handleErrorMessage();
        if (this.submitButton) {
          this.submitButton.setAttribute('aria-disabled', true); 
          this.submitButton.classList.add('loading');       
        }
        const loadingSpinner = this.querySelector('.loading-overlay__spinner');
        if (loadingSpinner) {
          loadingSpinner.classList.remove('hidden');
        }
        
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        if (this.submitButton) {
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage = this.submitButton ? this.submitButton.querySelector('.sold-out-message') : null;
                if (!soldOutMessage) return;
                if (this.submitButton) {
                  this.submitButton.setAttribute('aria-disabled', true);
                  this.submitButton.querySelector('span').classList.add('hidden');
                }
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
                manageProductAddToCart(response.handle,response.quantity,response.variant_id,'');
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              const loadingSpinner = this.querySelector('.loading-overlay__spinner');
              if (loadingSpinner) {
                loadingSpinner.classList.add('hidden');
              }
            });
        }
      }
      async getCart() {
        const response = await fetch('/cart.js');
        if (!response.ok) throw new Error("Error al obtener el carrito");
        return response.json();
      }

      checkPreorderInCart(cart) {
        return cart.items.some(item => item.properties?._preorder === 'true');
      }

      validateCart(hasPreorderInCart, isPreorder, cartItemCount) {
        if (hasPreorderInCart && !isPreorder) {
          return { isValid: false, message: window.error_message_normal };
        }
      
        if (!hasPreorderInCart && isPreorder && cartItemCount > 0) {
          return { isValid: false, message: window.error_message_preorder };
        }
      
        return { isValid: true, message: "" };
      }

      async getCart() {
        const response = await fetch('/cart.js');
        if (!response.ok) throw new Error("Error al obtener el carrito");
        return response.json();
      }

      checkPreorderInCart(cart) {
        return cart.items.some(item => item.properties?._preorder === 'true');
      }

      validateCart(hasPreorderInCart, isPreorder, cartItemCount) {
        if (hasPreorderInCart && !isPreorder) {
          return { isValid: false, message: window.error_message_normal };
        }
      
        if (!hasPreorderInCart && isPreorder && cartItemCount > 0) {
          return { isValid: false, message: window.error_message_preorder };
        }
      
        return { isValid: true, message: "" };
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
